import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DEFAULT_NEXT_PATH, QUERY_PARAM_NEXT } from '../constants';

// Same-origin guard: never let the `?next=` parameter redirect off-host.
// Anything not starting with `/` (and not `//` which is protocol-relative)
// is treated as untrusted and replaced with the safe default.
export function isSafeNext(value: string): boolean {
  if (value.length === 0) return false;
  if (!value.startsWith('/')) return false;
  if (value.startsWith('//')) return false;
  return true;
}

// Returns the safe same-origin `?next=` to carry through sign-in, or
// `DEFAULT_NEXT_PATH` (empty) when absent/unsafe. An empty result means
// "no opinion" — callers must omit `next` so the cloud lands the principal
// on its surface-appropriate home rather than forcing a destination.
export function useNextParam(): string {
  const [params] = useSearchParams();
  return useMemo(() => {
    const raw = params.get(QUERY_PARAM_NEXT) ?? '';
    return isSafeNext(raw) ? raw : DEFAULT_NEXT_PATH;
  }, [params]);
}
